import React, { useEffect, useState } from "react";
import "./returnOrderRequest.scss";
import sidebarActivePage from "../../stores/sidebarActivePage";
import TwoBreadcrumb from "../../components/breadcrumbs/TwoBreadcrumb";
import { Box, Paper, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import orderStore from "../../stores/orderStore";
import productStore from "../../stores/productStore";
import orderReturnRequestStore from "../../stores/orderReturnRequestStore";
import AllReturnOrderRequest from "./returnOrderRequestTab/AllReturnOrderRequest";
import usersStore from "../../stores/usersStore";
import ReturningReturnOrderRequest from "./returnOrderRequestTab/ReturningReturnOrderRequest";
import RequestReturnOrderRequest from "./returnOrderRequestTab/RequestReturnOrderRequest";
import ReturnedReturnOrderRequest from "./returnOrderRequestTab/ReturnedReturnOrderRequest";
import ReturnOrderRequestFilter from "./returnOrderRequestFilter/ReturnOrderRequestFilter";
import CancelReturnOrderRequest from "./returnOrderRequestTab/CancelReturnOrderRequest";

const ReturnOrderRequest = () => {
  const SidebarActivePage = sidebarActivePage();
  const OrderStore = orderStore();
  const ProductStore = productStore();
  const OrderReturnRequestStore = orderReturnRequestStore();
  const UsersStore = usersStore();

  const [allReturnOrderRequestCount, setAllReturnOrderRequestCount] =
    useState(0);
  const [requestReturnOrderRequestCount, setRequestReturnOrderRequestCount] =
    useState(0);
  const [returningReturnOrderRequestCount, setReturningOrderCount] =
    useState(0);
  const [returnedReturnOrderRequestCount, setReturnedOrderCount] = useState(0);
  const [cancelReturnOrderCount, setCancelReturnOrderCount] = useState(0);

  const [dataLoading, setDataLoading] = useState(true);
  const [allReturnOrderRequest, setAllReturnOrderRequest] = useState(null);

  useEffect(() => {
    SidebarActivePage.setIsActive({ setPage: "Return Order Request" });
  }, []);

  const [activeTab, setActiveTab] = useState("1");

  const handleChangeTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    if (
      !OrderStore.isLoading &&
      !ProductStore.isLoading &&
      !OrderReturnRequestStore.isLoading &&
      !UsersStore.isLoading
    ) {
      if (OrderReturnRequestStore.orderReturnRequest) {
        const allList = [];
        let status = "";
        const all = [];
        const request = [];
        const returning = [];
        const returned = [];
        const cancel = [];

        OrderReturnRequestStore.orderReturnRequest.map((rOrder) => {
          all.push(rOrder._id);
          if (rOrder.is_return_cancel) {
            cancel.push(rOrder._id);
            status = "Cancel";
          } else {
            if (
              rOrder.order_returning_status === false &&
              rOrder.order_return_status === false
            ) {
              request.push(rOrder._id);
              status = "Request";
            }
            if (
              rOrder.order_returning_status === true &&
              rOrder.order_return_status === false
            ) {
              returning.push(rOrder._id);
              status = "Returning";
            }
            if (
              rOrder.order_returning_status === false &&
              rOrder.order_return_status === true
            ) {
              returned.push(rOrder._id);
              status = "Returned";
            }
          }

          let totalQTY = 0;
          let productData = "";
          OrderStore.orderDetail.map((order) => {
            if (order._id === rOrder.orderID) {
              totalQTY = totalQTY + order.quantity;

              ProductStore.mProduct.map((product) => {
                if (order.productID === product._id) {
                  productData = {
                    _id: order._id,
                    productName: product.productName,
                    qty: order.quantity,
                    purchasePrice: order.purchasePrice,
                    size: order.selectedSize,
                    color: order.selectedColor?.toString(),
                  };
                }
              });
            }
          });

          let username = "";
          let email = "";
          UsersStore.allUser.map((user) => {
            if (user._id === rOrder.userID) {
              username = user.firstName + " " + user.lastName;
              email = user.email;
            }
          });

          allList.push({
            _id: rOrder.paymentID,
            returnOrderRequestID: rOrder._id,
            whyReturn: rOrder.whyReturn ? rOrder.whyReturn : "-",
            username,
            email,
            orderReturnRequestDate: rOrder.order_return_request_at,
            orderReturnDate: rOrder.order_return_at
              ? rOrder.order_return_at
              : "-",
            totalQTY,
            price: productData.purchasePrice * productData.qty,
            return_product: productData,
            status,
            is_return_cancel: rOrder.is_return_cancel,
            cancel_return_date: rOrder.cancel_return_date,
          });
        });

        setAllReturnOrderRequest(allList);

        setAllReturnOrderRequestCount(all.length);
        setRequestReturnOrderRequestCount(request.length);
        setReturningOrderCount(returning.length);
        setReturnedOrderCount(returned.length);
        setCancelReturnOrderCount(cancel.length);
      }

      setDataLoading(false);
    }
  }, [
    OrderStore.isLoading,
    ProductStore.isLoading,
    OrderReturnRequestStore.isLoading,
    UsersStore.isLoading,
  ]);

  const [orderID, setOrderID] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [staringRequestDate, setStaringRequestDate] = useState(null);
  const [endingRequestDate, setEndingRequestDate] = useState(null);
  const [staringReturnDate, setStaringReturnDate] = useState(null);
  const [endingReturnDate, setEndingReturnDate] = useState(null);
  const [staringPrice, setStaringPrice] = useState("");
  const [endingPrice, setEndingPrice] = useState("");
  const [status, setStatus] = useState("");

  return (
    <div className="return-order-request">
      <div className="heading">Return Order Request</div>
      <TwoBreadcrumb
        mainName="Return Order Request"
        mainLink="return-order-request"
        activeName="List"
      />
      {activeTab === "1" && (
        <div className="filter-content">
          <ReturnOrderRequestFilter
            orderID={orderID}
            setOrderID={setOrderID}
            customerName={customerName}
            setCustomerName={setCustomerName}
            staringRequestDate={staringRequestDate}
            setStaringRequestDate={setStaringRequestDate}
            endingRequestDate={endingRequestDate}
            setEndingRequestDate={setEndingRequestDate}
            staringReturnDate={staringReturnDate}
            setStaringReturnDate={setStaringReturnDate}
            endingReturnDate={endingReturnDate}
            setEndingReturnDate={setEndingReturnDate}
            staringPrice={staringPrice}
            setStaringPrice={setStaringPrice}
            endingPrice={endingPrice}
            setEndingPrice={setEndingPrice}
            status={status}
            setStatus={setStatus}
          />
        </div>
      )}

      <Paper sx={{ width: "100%", mb: 2, mt: 4 }}>
        <TabContext value={activeTab}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChangeTab}
              aria-label="lab API tabs example"
              className="tab-list"
              variant="scrollable"
            >
              <Tab
                className="tab"
                label={
                  <p className={activeTab === "1" ? "active-all" : ""}>
                    All{" "}
                    <span className="all">{allReturnOrderRequestCount}</span>
                  </p>
                }
                value="1"
              />
              <Tab
                className="tab"
                label={
                  <p className={activeTab === "2" ? "active-request" : ""}>
                    Request{" "}
                    <span className="request">
                      {requestReturnOrderRequestCount}
                    </span>
                  </p>
                }
                value="2"
              />
              <Tab
                className="tab"
                label={
                  <p className={activeTab === "3" ? "active-returning" : ""}>
                    Returning{" "}
                    <span className="returning">
                      {returningReturnOrderRequestCount}
                    </span>
                  </p>
                }
                value="3"
              />
              <Tab
                className="tab"
                label={
                  <p className={activeTab === "4" ? "active-returned" : ""}>
                    Returned{" "}
                    <span className="returned">
                      {returnedReturnOrderRequestCount}
                    </span>
                  </p>
                }
                value="4"
              />
              <Tab
                className="tab"
                label={
                  <p className={activeTab === "5" ? "active-cancel" : ""}>
                    Cancel{" "}
                    <span className="cancel">{cancelReturnOrderCount}</span>
                  </p>
                }
                value="5"
              />
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ p: 0 }}>
            <AllReturnOrderRequest
              dataLoading={dataLoading}
              allReturnOrderRequest={allReturnOrderRequest}
              orderID={orderID}
              customerName={customerName}
              staringRequestDate={staringRequestDate}
              endingRequestDate={endingRequestDate}
              staringReturnDate={staringReturnDate}
              endingReturnDate={endingReturnDate}
              staringPrice={staringPrice}
              endingPrice={endingPrice}
              status={status}
            />
          </TabPanel>
          <TabPanel value="2" sx={{ p: 0 }}>
            <RequestReturnOrderRequest
              dataLoading={dataLoading}
              allReturnOrderRequest={allReturnOrderRequest}
            />
          </TabPanel>
          <TabPanel value="3" sx={{ p: 0 }}>
            <ReturningReturnOrderRequest
              dataLoading={dataLoading}
              allReturnOrderRequest={allReturnOrderRequest}
            />
          </TabPanel>
          <TabPanel value="4" sx={{ p: 0 }}>
            <ReturnedReturnOrderRequest
              dataLoading={dataLoading}
              allReturnOrderRequest={allReturnOrderRequest}
            />
          </TabPanel>
          <TabPanel value="5" sx={{ p: 0 }}>
            <CancelReturnOrderRequest
              dataLoading={dataLoading}
              allReturnOrderRequest={allReturnOrderRequest}
            />
          </TabPanel>
        </TabContext>
      </Paper>
    </div>
  );
};

export default ReturnOrderRequest;
